
import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ContactModal from './ContactModal';
import Swal from 'sweetalert2';
// import { BsPencil, BsCheck, BsX } from "react-icons/bs";
import { BsSearch, BsPlus, BsPencil, BsCheck, BsX, BsTrash, BsEnvelope, BsPerson, BsTelephone, BsBriefcase } from "react-icons/bs";
import { FaUserTag } from "react-icons/fa";
import ReactDOM from "react-dom";


const backendUrl = process.env.REACT_APP_BACKEND_URL;

const SelectedContact = React.forwardRef(({
    clientData,
    setClientDetails,
    leadData,
    setLeadDetails,
    projectData,
    setProjectDetails,
    organisationData,
    organisationId,
    setOrganisationDetails,
    entityType,
    leadId,
    dealData,
    setDealDetails,
    hideList = false,
    clientId, projectId,
    dealId, instanceId, instanceData, setInstanceDetails, tenantId, tenantData, setTenantDetails, onCloseOffcanvas, onReopenOffcanvas, showContactModal: propShowContactModal, setShowContactModal: propSetShowContactModal, onShowModal,
    fetchLeadData,
    fetchOrganisationData,
    fetchProjectData,
    fetchClientData,
    fetchDealData,
    fetchInstanceData,
    fetchTenantData
}, ref) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedContacts, setSelectedContacts] = useState(clientData?.contacts || []);
    const [filteredContacts, setFilteredContacts] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [contacts, setContacts] = useState([]);
    const [isDeleting, setIsDeleting] = useState(false);

    const [saved, setSaved] = useState(false);
    const dropdownRef = useRef(null);
    const [shouldShowSaveButton, setShouldShowSaveButton] = useState(false);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ 
        name: '', 
        email: '', 
        phone: '', 
        position: '', 
        contact_type: '', 
        type_id: '' 
    });
    const [errors, setErrors] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const debounceTimeoutRef = useRef(null);
    const [localShowContactModal, setLocalShowContactModal] = useState(false);
    const showContactModal = propShowContactModal !== undefined ? propShowContactModal : localShowContactModal;
    const setShowContactModal = propSetShowContactModal !== undefined ? propSetShowContactModal : setLocalShowContactModal;


    const entityIdMap = {
        client: clientId || clientData?.id,
        project: projectId || projectData?.id,
        org: organisationId || organisationData?.id,
        lead: leadId || leadData?.id,
        deal: dealId || dealData?.id,
        instance: instanceId || instanceData?.id,
        tenant: tenantId || tenantData?.id,
    };
    const debounce = (func, delay) => {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => func(...args), delay);
        };
    };

    const fetchContact = async (query, setFilteredContacts, setIsDropdownOpen) => {
        if (!query.trim()) {
            setFilteredContacts([]);
            setIsDropdownOpen(false);
            return;
        }

        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const origin = localStorage.getItem("user-origin");
        const token = userInfo?.token;

        try {
            const response = await axios.get(`${backendUrl}/api/contact?search=${query}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            console.log("API Response:", response.data);

            const filteredContacts = response.data.Data.filter(contact =>
                !selectedContacts.some(selected => selected.id === contact.id)
            );

            console.log("Filtered Contacts:", filteredContacts);

            setFilteredContacts(filteredContacts);
            setIsDropdownOpen(filteredContacts.length > 0);
        } catch (error) {
            console.error("Error fetching contacts:", error);
        }
    };

    // ✅ Memoized Debounced Function (Prevents recreation on every render)
    const debouncedFetchContacts = useCallback(debounce(fetchContact, 500), []);

    useEffect(() => {
        debouncedFetchContacts(searchQuery, setFilteredContacts, setIsDropdownOpen);
    }, [searchQuery]);


    // ✅ Combined and optimized effect to sync prop data to local state
    useEffect(() => {
        let contactsToSet = [];
        if (entityType === 'client' && clientData?.contacts) {
            contactsToSet = clientData.contacts;
        } else if (entityType === 'project') {
            // Priority: project_team relationship for internal, contacts for shared/external
            const team = projectData?.project_team || [];
            const standardContacts = projectData?.contacts || [];
            
            // Merge team members with standard contacts for a unified view
            const combined = [...team, ...standardContacts.filter(sc => !team.some(t => t.id === sc.id))];
            
            contactsToSet = combined.map(contact => ({
                ...contact,
                position: contact.pivot?.position || contact?.position || '',
                sendemail_to_project: contact.pivot?.sendemail_to_project || '',
                receive_updates: contact.pivot?.receive_updates || '',
            }));
        } else if (entityType === 'org' && organisationData?.contacts) {
            contactsToSet = organisationData.contacts;
        } else if (entityType === 'lead' && leadData?.contacts) {
            contactsToSet = leadData.contacts;
        } else if (entityType === 'deal' && dealData?.contacts) {
            contactsToSet = dealData.contacts;
        } else if (entityType === 'instance' && instanceData?.contacts) {
            contactsToSet = instanceData.contacts;
        } else if (entityType === 'tenant' && tenantData?.contacts) {
            contactsToSet = tenantData.contacts;
        }

        if (contactsToSet.length > 0) {
            setSelectedContacts(contactsToSet);
        }
    }, [clientData, projectData, organisationData, entityType, leadData, dealData, instanceData, tenantData]);

    const handleSelectContact = (contact) => {
        const isContactSelected = selectedContacts.some(c => c.id === contact.id);
        let updatedContacts;

        if (isContactSelected) {
            // If the contact is already selected, remove it
            updatedContacts = selectedContacts.filter(c => c.id !== contact.id);
        } else {
            // If the contact is not selected, add it
            updatedContacts = [...selectedContacts, contact];
        }
        console.log('Updated Contacts:', updatedContacts); // Debugging log

        setSelectedContacts(updatedContacts);
        setShouldShowSaveButton(updatedContacts.length > 0 || searchQuery.trim() !== '');
    };



    //     const handleDeleteContact = async (contactId) => {
    //         if (isDeleting) return;
    //         setIsDeleting(true);
    // if (onCloseOffcanvas) onCloseOffcanvas();

    //         Swal.fire({
    //             title: "Are you sure?",
    //             text: "You won't be able to revert this!",
    //             icon: "warning",
    //             showCancelButton: true,
    //             confirmButtonColor: "#d33",
    //             cancelButtonColor: "#3085d6",
    //             confirmButtonText: "Yes, delete it!",
    //             cancelButtonText: "Cancel"
    //         }).then(async (result) => {
    //             console.log("Swal result:", result);
    //             if (!result.isConfirmed) {
    //                 setIsDeleting(false);
    //                 return; // Stop execution if canceled
    //             }

    //             try {
    //                 const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //                 const origin = localStorage.getItem('user-origin');
    //                 const token = userInfo?.token;

    //                 const endpoint = entityType === 'client' ? `${backendUrl}/api/contact/${contactId}?type=client`
    //                     : entityType === 'project' ? `${backendUrl}/api/contact/${contactId}?type=project`
    //                         : entityType === 'org' ? `${backendUrl}/api/contact/${contactId}?type=org`
    //                             : entityType === 'lead' ? `${backendUrl}/api/contact/${contactId}?type=lead`
    //                                 : entityType === 'deal' ? `${backendUrl}/api/contact/${contactId}?type=deal`
    //                                     : entityType === 'instance' ? `${backendUrl}/api/contact/${contactId}?type=instance`
    //                                         : entityType === 'tenant' ? `${backendUrl}/api/contact/${contactId}?type=tenant`
    //                                             : null;
    //                 if (!endpoint) {
    //                     console.error("Invalid entityType:", entityType);
    //                     Swal.fire({
    //                         toast: true,
    //                         position: 'top-end',
    //                         icon: 'error',
    //                         title: 'Invalid entity type. Cannot delete contact.',
    //                         timer: 3000,
    //                         timerProgressBar: false,
    //                         showConfirmButton: false,
    //                         didOpen: () => {
    //                             // Adjust the container's position if needed
    //                             const container = Swal.getContainer();
    //                             container.style.top = '50px'; // Change this value as desired
    //                         }
    //                     });
    //                     setIsDeleting(false);
    //                     return;
    //                 }

    //                 const response = await axios.delete(endpoint, {
    //                     headers: {
    //                         Authorization: `Bearer ${token}`,
    //                         'Tenant-Origin': origin,
    //                     },
    //                 });

    //                 if (response.status === 200 || response.status === 204) {
    //                     // Remove the deleted contact from local state
    //                     const updatedContacts = selectedContacts.filter(contact => contact.id !== contactId);
    //                     setSelectedContacts(updatedContacts);


    //                     if (entityType === 'client') {
    //                         setClientDetails(prev => ({ ...prev, contacts: updatedContacts }));
    //                     } else if (entityType === 'project') {
    //                         setProjectDetails(prev => ({ ...prev, contacts: updatedContacts }));
    //                     } else if (entityType === 'org') {
    //                         setOrganisationDetails(prev => ({ ...prev, contacts: updatedContacts }));
    //                     } else if (entityType === 'lead') {
    //                         setLeadDetails(prev => ({ ...prev, contacts: updatedContacts }));
    //                     } else if (entityType === 'deal') {
    //                         setDealDetails(prev => ({ ...prev, contacts: updatedContacts }));
    //                     } else if (entityType === 'instance') {
    //                         setInstanceDetails(prev => ({ ...prev, contacts: updatedContacts }));
    //                     } else if (entityType === 'tenant') {
    //                         setTenantDetails(prev => ({ ...prev, contacts: updatedContacts }));
    //                     }

    //                     // Show success alert
    //                     Swal.fire("Deleted!", "The contact has been deleted.", "success");
    //                 } else {
    //                     console.error("Unexpected response status:", response.status);
    //                     Swal.fire({
    //                         toast: true,
    //                         position: 'top-end',
    //                         icon: 'error',
    //                         title: 'Failed to delete contact. Please try again.',
    //                         timer: 3000,
    //                         timerProgressBar: false,
    //                         showConfirmButton: false,
    //                         didOpen: () => {
    //                             // Adjust the container's position if needed
    //                             const container = Swal.getContainer();
    //                             container.style.top = '50px'; // Change this value as desired
    //                         }
    //                     });
    //                 }
    //             } catch (error) {
    //                 console.error('Error deleting contact:', error);
    //                 Swal.fire("Error!", "Failed to delete contact. Please try again.", "error");
    //             } finally {
    //                 setIsDeleting(false);
    //             }
    //         });
    //     };

    const handleDeleteContact = async (contactId) => {
        if (isDeleting) return;
        setIsDeleting(true);

        // Hide offcanvas immediately
        if (onCloseOffcanvas) onCloseOffcanvas();

        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const endpoint = entityType === 'client' ? `${backendUrl}/api/contact/${contactId}?type=client`
                : entityType === 'project' ? `${backendUrl}/api/contact/${contactId}?type=project`
                    : entityType === 'org' ? `${backendUrl}/api/contact/${contactId}?type=org`
                        : entityType === 'lead' ? `${backendUrl}/api/contact/${contactId}?type=lead`
                            : entityType === 'deal' ? `${backendUrl}/api/contact/${contactId}?type=deal`
                                : entityType === 'instance' ? `${backendUrl}/api/contact/${contactId}?type=instance`
                                    : entityType === 'tenant' ? `${backendUrl}/api/contact/${contactId}?type=tenant`
                                        : null;

            if (!endpoint) throw new Error("Invalid entityType");

            const response = await axios.delete(endpoint, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true, // Custom flag to skip global loader if implemented
            });

            if (response.status === 200 || response.status === 204) {
                // Update local state
                const updatedContacts = selectedContacts.filter(c => c.id !== contactId);
                setSelectedContacts(updatedContacts);

                if (entityType === 'client') setClientDetails(prev => ({ ...prev, contacts: updatedContacts }));
                else if (entityType === 'project') setProjectDetails(prev => ({ ...prev, contacts: updatedContacts }));
                else if (entityType === 'org') setOrganisationDetails(prev => ({ ...prev, contacts: updatedContacts }));
                else if (entityType === 'lead') setLeadDetails(prev => ({ ...prev, contacts: updatedContacts }));
                else if (entityType === 'deal') setDealDetails(prev => ({ ...prev, contacts: updatedContacts }));
                else if (entityType === 'instance') setInstanceDetails(prev => ({ ...prev, contacts: updatedContacts }));
                else if (entityType === 'tenant') setTenantDetails(prev => ({ ...prev, contacts: updatedContacts }));

                // Show success toast
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Contact deleted successfully!',
                    timer: 2000,
                    showConfirmButton: false,
                });
            } else {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Failed to delete contact!',
                    timer: 2000,
                    showConfirmButton: false,
                });
            }
        } catch (error) {
            console.error('Error deleting contact:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Error deleting contact!',
                timer: 2000,
                showConfirmButton: false,
            });
        } finally {
            setIsDeleting(false);
            // Reopen offcanvas after deletion if needed
            if (onReopenOffcanvas) onReopenOffcanvas();
        }
    };




    const handlePositionChange = (contactId, newPosition) => {
        setSelectedContacts((prevContacts) =>
            prevContacts.map((contact) =>
                contact.id === contactId ? { ...contact, position: newPosition } : contact
            )
        );
        setShouldShowSaveButton(true); // Show the save button if a position is edited
    };
    const updateContacts = async (manualContacts = null) => {
        const contactsToSync = manualContacts || selectedContacts;
        if (!contactsToSync.length) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'No contacts selected!',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    // Adjust the container's position if needed
                    const container = Swal.getContainer();
                    container.style.top = '50px'; // Change this value as desired
                }
            }); return;
        }

        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const updatedData = {
                name: (clientData && clientData.name) || (projectData && projectData.name) || (organisationData && organisationData.name) || (leadData && leadData.name) || (dealData && dealData.name) || (tenantData && tenantData.name) || ' ',
                code: projectData?.code || '',
                setup_name: instanceData && instanceData.setup_name,
                setup_id: instanceData?.setup_id,
                tenant_id: tenantData?.tenant_id,
                instance_id: tenantData?.instance_id,
                account_status: tenantData?.account_status,
                contacts: contactsToSync.map(contact => ({
                    id: contact.id,
                    position: contact.position || '',
                    sendemail_to_project: contact.pivot?.sendemail_to_project || "false", // default to "false"
                })),
                contact_ids: contactsToSync.map(c => c.id) // Fallback for some backend modules
            };
            const currentEntityId = (
                (entityType === 'project' && (projectId || projectData?.id)) ||
                (entityType === 'client' && (clientId || clientData?.id)) ||
                (entityType === 'lead' && (leadId || leadData?.id)) ||
                (entityType === 'org' && (organisationId || organisationData?.id)) ||
                (entityType === 'deal' && (dealId || dealData?.id)) ||
                (entityType === 'instance' && (instanceId || instanceData?.id)) ||
                (entityType === 'tenant' && (tenantId || tenantData?.id))
            );

            console.log("Syncing contacts for", entityType, "ID:", currentEntityId, "Data:", updatedData);
            let response;
            if (entityType === 'client' && currentEntityId) {
                response = await axios.put(
                    `${backendUrl}/api/contacts/${currentEntityId}?type=client`,
                    updatedData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            'Tenant-Origin': origin,
                        },
                    }
                );
            } else if (entityType === 'project' && currentEntityId) {
                // Projects require a simplified payload for the project_team sync
                response = await axios.put(
                    `${backendUrl}/api/projects/${currentEntityId}`,
                    {
                        name: projectData.name,
                        code: projectData.code,
                        project_team: contactsToSync.map(contact => ({ 
                            id: contact.id,
                            sendemail_to_project: contact.pivot?.sendemail_to_project || "false",
                            receive_updates: contact.pivot?.receive_updates || "false" 
                        })),
                        contact_ids: contactsToSync.map(c => c.id) // Fallback support
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            'Tenant-Origin': origin,
                        },
                    }
                );
            } else if (entityType === 'org' && currentEntityId) {
                response = await axios.put(
                    `${backendUrl}/api/organisation/${currentEntityId}`,
                    updatedData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            'Tenant-Origin': origin,
                        },
                    }
                );
            } else if (entityType === 'lead') {
                response = await axios.put(
                    `${backendUrl}/api/leads/${leadId}`,
                    updatedData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            'Tenant-Origin': origin,
                        },
                    }
                );
            } else if (entityType === 'deal') {
                response = await axios.put(
                    `${backendUrl}/api/deals/${dealId}`,
                    updatedData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            'Tenant-Origin': origin,
                        },
                    }
                );
            } else if (entityType === 'instance') {
                response = await axios.put(
                    `${backendUrl}/api/instance-info/${instanceId}`,
                    updatedData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            'Tenant-Origin': origin,
                        },
                    }
                );
            } else if (entityType === 'tenant') {
                response = await axios.put(
                    `${backendUrl}/api/tenants/${tenantId}`,
                    updatedData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            'Tenant-Origin': origin,
                        },
                    }
                );
            }

            if (response.status === 200 || response.status === 204) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Contact Update successfully!',
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        // Adjust the container's position if needed
                        const container = Swal.getContainer();
                        container.style.top = '50px'; // Change this value as desired
                    }
                });
                // Update the local state with the returned pivot data
                const updatedContacts = response.data.Data.contacts.map(contact => ({
                    ...contact,

                    position: contact.pivot?.position || '',
                    sendemail_to_project: contact.pivot?.sendemail_to_project || "false",
                }));
                setSelectedContacts(updatedContacts);
                console.log('Updated Client Data:', response.data.Data);

                // Optionally update parent state
                if (entityType === 'client') {
                    setClientDetails(prev => ({
                        ...prev,
                        contacts: updatedContacts,
                    }));
                } else if (entityType === 'project') {
                    setProjectDetails(prev => ({
                        ...prev,
                        contacts: updatedContacts,
                    }));
                } else if (entityType === 'org') {
                    setOrganisationDetails(prev => ({
                        ...prev,
                        contacts: updatedContacts,
                    }));
                } else if (entityType === 'lead') {
                    setLeadDetails(prev => ({
                        ...prev,
                        contacts: updatedContacts,

                    }));
                } else if (entityType === 'deal') {
                    setDealDetails(prev => ({
                        ...prev,
                        contacts: updatedContacts,

                    }));
                } else if (entityType === 'instance') {
                    setInstanceDetails(prev => ({
                        ...prev,
                        contacts: updatedContacts,

                    }));
                } else if (entityType === 'tenant') {
                    setTenantDetails(prev => ({
                        ...prev,
                        contacts: updatedContacts,

                    }));
                }


                setShouldShowSaveButton(false); // Hide save button
                setIsDropdownOpen(false);
                setSearchQuery('');
            } else {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Failed the updation.',
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        // Adjust the container's position if needed
                        const container = Swal.getContainer();
                        container.style.top = '50px'; // Change this value as desired
                    }
                });
            }
        } catch (error) {
            console.error('Error saving pivot table positions:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Error saving positions. Please try again.',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    // Adjust the container's position if needed
                    const container = Swal.getContainer();
                    container.style.top = '50px'; // Change this value as desired
                }
            });
        }
    };

    // Redundant useEffect removed. Mapping logic is now in the consolidated effect at the top.


    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setShouldShowSaveButton(selectedContacts.length > 0 || e.target.value.trim() !== ''); // Update the button visibility based on selection or search
    };

    const [leadDataUpdated, setLeadDataUpdated] = useState(false);


    useEffect(() => {
        if (saved) {
            setSaved(false); // Reset saved state
        }
    }, [searchQuery]);

    // Close dropdown when clicking outside
    const handleClickOutside = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setSearchQuery('');
            setIsDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    // const handleAddContact = () => {
    //     setFormData({ name: '', email: '', phone: '', position: '' });
    //     setIsEdit(false);
    //     // setshowContactModal (true);
    //      if (onCloseOffcanvas) {
    //         onCloseOffcanvas();
    //     }
    //     setTimeout(() => {
    //         setshowContactModal (true);
    //     }, 300);
    // };

    //     const handleAddContact = () => {
    //         setFormData({ name: '', email: '', phone: '', position: '' });
    //         setIsEdit(false);

    //         setShowContactModal(true);

    // setTimeout(() => {
    //     if (onCloseOffcanvas) onCloseOffcanvas();
    // }, 300);

    //     };

    //     const handleModalClose = () => {
    //         console.log("🔴 handleModalClose called");
    //         setShowContactModal(false); // Use the prop setter

    //         if (onReopenOffcanvas) {
    //             console.log("🟢 Calling onReopenOffcanvas to reopen offcanvas");
    //             setTimeout(() => {
    //                 onReopenOffcanvas();
    //             }, 400);
    //         }
    //     };


    const handleAddContact = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (onShowModal) {
            onShowModal(false, { 
                name: '', 
                email: '', 
                phone: '', 
                position: '',
                contact_type: '',
                type_id: ''
            });
            if (onCloseOffcanvas) onCloseOffcanvas();
        } else {
            setFormData({ 
                name: '', 
                email: '', 
                phone: '', 
                position: '',
                contact_type: '',
                type_id: ''
            });
            setIsEdit(false);
            setShowContactModal(true);

            // Hide Offcanvas immediately
            if (onCloseOffcanvas) onCloseOffcanvas();
        }
    };



    const handleModalClose = useCallback(() => {
        setShowContactModal(false);

        // Notify parent that the offcanvas should reopen
        if (onReopenOffcanvas) {
            onReopenOffcanvas();
        }
    }, [setShowContactModal, onReopenOffcanvas]);

    // Handle modal input changes
    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        
        // Update form data state
        setFormData((prev) => ({ ...prev, [name]: value }));

        // Clear error for this field using functional update for stability
        setErrors((prev) => {
            if (prev && prev[name]) {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            }
            return prev;
        });
    }, []);
    useEffect(() => {
        if (!showContactModal) {
            setErrors({});
        }
    }, [showContactModal]);

    const validateForm = (data = formData) => {
        const newErrors = {};
        // User only requires Name, Email, Phone
        if (!data.name) newErrors.name = 'Name is required';
        if (!data.email) newErrors.email = 'Email is required';
        if (!data.phone) newErrors.phone = 'Phone is required';

        // Email is optional in frontend validation, but we can add basic format check if not empty
        if (data.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
            newErrors.email = 'Invalid email format';
        }

        return newErrors;
    };
    const [loading, setLoading] = useState(false);
    const handleSubmit = useCallback(async (manualData = null) => {
        setLoading(true); // Start loading

        // If first arg is a React event, ignore it and use internal formData
        const isEvent = manualData && (manualData.nativeEvent || manualData.target);
        const dataToSubmit = (manualData && !isEvent) ? manualData : formData;

        const validationErrors = validateForm(dataToSubmit);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return { success: false, errors: validationErrors };
        }

        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info') || '{}');
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            let response;

            // Determine the correct entity ID and field name
            const internalEntityIdMap = {
                client: clientId,
                project: projectId,
                org: organisationId,
                lead: leadId,
                deal: dealId,
                instance: instanceId,
                tenant: tenantId,
            };

            const entityId = internalEntityIdMap[entityType] || null;
            const normalizedType = entityType?.toLowerCase() || '';
            const specificIdField = (normalizedType === 'org') ? 'organisation_id' : `${normalizedType}_id`;

            const contactPayload = {
                ...dataToSubmit,
                mobile: dataToSubmit.phone, // Duplicate as mobile for broad compatibility
                [specificIdField]: entityId,
                contact_id: entityId,
                documentable_id: entityId,
                documentable_type: entityType ? (entityType.charAt(0).toUpperCase() + entityType.slice(1)) : null,
                entity_id: entityId,
                entity_type: entityType,
                contact_id: dataToSubmit.id || entityId, // Fallback for various backend versions
                type: entityType,
            };

            console.log("Saving contact for", entityType, "with entityId:", entityId, "payload:", contactPayload);

            let resultContact;
            if (isEdit) {
                response = await axios.put(`${backendUrl}/api/contact/${formData.id}`, contactPayload, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                        'Content-Type': 'application/json'
                    },
                });
                resultContact = response?.data?.Data || response?.data?.data || response?.data?.contact || { ...contactPayload, id: formData.id };
            } else {
                response = await axios.post(`${backendUrl}/api/contact`, contactPayload, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                        'Content-Type': 'application/json'
                    },
                });
                resultContact = response?.data?.Data || response?.data?.data || response?.data?.contact;
            }

            if (!resultContact) {
                console.error("No contact data in response:", response?.data);
                throw new Error("Invalid response from server");
            }

            // Synthesize UI-ready contact with expected pivot structure
            const uiContact = {
                ...resultContact,
                position: resultContact.position || dataToSubmit.position || '',
                pivot: {
                    position: resultContact.position || dataToSubmit.position || '',
                    sendemail_to_project: resultContact.pivot?.sendemail_to_project || "false"
                }
            };

            // Update local list
            setSelectedContacts((prev) => {
                const exists = prev.some(c => c.id === uiContact.id);
                if (exists) {
                    return prev.map(c => c.id === uiContact.id ? uiContact : c);
                }
                return [uiContact, ...prev];
            });

            // Update parent state for immediate reflection in details view
            const updateParentMap = {
                client: setClientDetails,
                project: setProjectDetails,
                org: setOrganisationDetails,
                lead: setLeadDetails,
                deal: setDealDetails,
                instance: setInstanceDetails,
                tenant: setTenantDetails,
            };

            const parentSetter = updateParentMap[entityType];
            if (parentSetter) {
                parentSetter(prev => {
                    if (!prev) return prev;
                    const contacts = prev.contacts ? [...prev.contacts] : [];
                    const idx = contacts.findIndex(c => c.id === uiContact.id);
                    if (idx !== -1) {
                        contacts[idx] = uiContact;
                    } else {
                        contacts.unshift(uiContact);
                    }
                    return { ...prev, contacts };
                });
            }

            // Persistence: Sync the whole list to the pivot table
            const nextSelectedContacts = selectedContacts.some(c => c.id === uiContact.id)
                ? selectedContacts.map(c => c.id === uiContact.id ? uiContact : c)
                : [uiContact, ...selectedContacts];
            
            await updateContacts(nextSelectedContacts);

            // Fallback: Trigger parent fetch functions
            if (fetchLeadData) fetchLeadData();
            if (fetchOrganisationData) fetchOrganisationData();
            if (entityType === 'project' && fetchProjectData) fetchProjectData();
            if (entityType === 'client' && fetchClientData) fetchClientData();
            if (entityType === 'deal' && fetchDealData) fetchDealData();
            if (entityType === 'instance' && fetchInstanceData) fetchInstanceData();
            if (entityType === 'tenant' && fetchTenantData) fetchTenantData();

            // Notify UI state
            setErrors({});
            const setter = propSetShowContactModal || setShowContactModal;
            setter(false);

            if (onReopenOffcanvas) onReopenOffcanvas();
            
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: isEdit ? 'Contact updated successfully' : 'Contact added successfully',
                showConfirmButton: false,
                timer: 3000
            });

            return { success: true };
        } catch (error) {
            console.error("Error adding contact: ", error);
            let backendErrors = {};
            if (error.response?.data?.errors) {
                backendErrors = error.response.data.errors;
                setErrors(backendErrors);
            } else {
                backendErrors = { apiError: "Failed to save contact. Please try again." };
                setErrors(backendErrors);
            }
            return { success: false, errors: backendErrors };
        } finally {
            setLoading(false); // Stop loading after API call
        }
    }, [formData, isEdit, entityType, clientId, projectId, organisationId, leadId, dealId, instanceId, tenantId, propSetShowContactModal, setShowContactModal, onReopenOffcanvas, setClientDetails, setProjectDetails, setOrganisationDetails, setLeadDetails, setDealDetails, setInstanceDetails, setTenantDetails, backendUrl, fetchLeadData, fetchOrganisationData, fetchProjectData, fetchClientData, fetchDealData, fetchInstanceData, fetchTenantData, selectedContacts, updateContacts]);




    const handleNotifyToggle = (contactId) => {
        setSelectedContacts((prevContacts) =>
            prevContacts.map((contact) =>
                contact.id === contactId
                    ? {
                        ...contact,
                        pivot: {
                            ...contact.pivot,
                            sendemail_to_project: contact.pivot?.sendemail_to_project === "true" ? "false" : "true"
                        }
                    }
                    : contact
            )
        );
        setShouldShowSaveButton(true); // Show save button when toggling
    };
    const [editingPositionId, setEditingPositionId] = useState(null);

    const savePosition = (id) => {
        setEditingPositionId(null); // Exit edit mode
        console.log('Saved position for', id); // Replace with actual save logic
    };
    // Expose methods to parent components
    React.useImperativeHandle(ref, () => ({
        handleSubmit,
        handleManualInputChange: handleInputChange,
        getFormData: () => formData,
        setFormData,
        setIsEdit,
        setShowModal: setShowContactModal,
        getErrors: () => errors
    }), [handleSubmit, handleInputChange, formData, errors, setIsEdit, setShowContactModal]);

    if (hideList) return null;
    return (
        <div className="selected-contact-modern">
            {/* Header Section */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h6 className="fw-semibold text-dark mb-1">Contact Management</h6>

                </div>
                <div className="d-flex align-items-center gap-2">
                    <span className="badge bg-primary fs-12">
                        {entityType?.toUpperCase()}
                    </span>
                </div>
            </div>

            {/* Search and Add Section */}
            <div className="row g-3 mb-4">
                <div className="col-md-8">
                    <div className="search-box-modern position-relative">
                        <BsSearch className="search-icon-modern" />
                        <input
                            type="text"
                            className="form-control search-input-modern"
                            placeholder="Search contacts by name, email, or position..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />

                        {isDropdownOpen && filteredContacts.length > 0 && (
                            <div ref={dropdownRef} className="search-dropdown-modern">
                                {filteredContacts.map(contact => (
                                    <div
                                        key={contact.id}
                                        className="search-dropdown-item"
                                        onClick={() => handleSelectContact(contact)}
                                    >
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={selectedContacts.some(c => c.id === contact.id)}
                                                    onChange={() => { }}
                                                />
                                            </div>
                                            <div className="flex-grow-1">
                                                <div className="fw-semibold text-dark">{contact.name}</div>
                                                <div className="text-muted small">{contact.email}</div>
                                            </div>
                                            <span className="badge bg-light text-dark fs-11">
                                                {contact.contact_type}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-md-4">
                    <button
                        className="btn btn-outline-primary btn-sm w-100 d-flex align-items-center justify-content-center gap-1"
                        onClick={handleAddContact}
                    >
                        <BsPlus size={14} />
                        Add Contact
                    </button>
                </div>

            </div>

            {/* Contacts Table */}
            <div className="contacts-table-modern">
                <div className="table-responsive">
                    <table className="table table-modern">
                        <thead>
                            <tr>
                                <th className="ps-4">
                                    Contact
                                </th>
                                <th>
                                    Email
                                </th>
                                <th>
                                    Phone
                                </th>
                                <th>
                                    Position
                                </th>
                                <th>
                                    Type
                                </th>
                                {entityType === 'project' && (
                                    <th className="text-center">
                                        <BsEnvelope className="me-2" size={14} />
                                        Notify
                                    </th>
                                )}
                                <th className="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedContacts.length > 0 ? (
                                selectedContacts.map(contact => (
                                    <tr key={contact.id} className="contact-row">
                                        <td className="ps-4">
                                            <div className="d-flex align-items-center">
                                                <div className="contact-avatar bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3">
                                                    <BsPerson className="text-primary" size={16} />
                                                </div>
                                                <div>
                                                    <div className="fw-semibold text-dark">{contact.name}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="text-dark">{contact.email}</div>
                                        </td>
                                        <td>
                                            <div className="text-dark">{contact.phone}</div>
                                        </td>
                                        <td>
                                            {editingPositionId === contact.id ? (
                                                <div className="d-flex align-items-center gap-2">
                                                    <input
                                                        type="text"
                                                        value={contact.position || ''}
                                                        onChange={(e) => handlePositionChange(contact.id, e.target.value)}
                                                        className="form-control form-control-sm"
                                                        style={{ width: '140px' }}
                                                        autoFocus
                                                    />
                                                    <BsCheck
                                                        className="text-success cursor-pointer"
                                                        onClick={() => savePosition(contact.id)}
                                                        size={16}
                                                    />
                                                    <BsX
                                                        className="text-danger cursor-pointer"
                                                        onClick={() => setEditingPositionId(null)}
                                                        size={16}
                                                    />
                                                </div>
                                            ) : (
                                                <div
                                                    className="position-editable d-flex align-items-center gap-2"
                                                    onClick={() => setEditingPositionId(contact.id)}
                                                >
                                                    <span className={contact.position ? 'text-dark' : 'text-muted'}>
                                                        {contact.position || 'Click to add position'}
                                                    </span>
                                                    <BsPencil className="text-primary" size={12} />
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            <span className="badge bg-light text-dark fs-11">
                                                {contact.contact_type || 'N/A'}
                                            </span>
                                        </td>
                                        {entityType === 'project' && (
                                            <td className="text-center">
                                                <div className="form-check form-switch d-inline-block">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={contact.pivot?.sendemail_to_project === "true"}
                                                        onChange={() => handleNotifyToggle(contact.id)}
                                                    />
                                                </div>
                                            </td>
                                        )}
                                        <td className="text-center">
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => handleDeleteContact(contact.id)}
                                                disabled={isDeleting}
                                            >
                                                <BsTrash size={14} />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={entityType === 'project' ? 7 : 6} className="text-center py-5">
                                        <div className="text-muted">
                                            <BsPerson size={32} className="mb-2 opacity-50" />
                                            <div>No contacts added yet</div>
                                            <small>Use the search bar above to add contacts</small>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Save Button */}
            {shouldShowSaveButton && (
                <div className="d-flex justify-content-end mt-4 pt-3 border-top">
                    <button
                        className="btn btn-primary px-4"
                        onClick={updateContacts}
                    >
                        Save Changes
                    </button>
                </div>
            )}

            {/* Contact Modal */}
            {/* <ContactModal
                showContactModal ={showContactModal }
                // handleClose={() => setshowContactModal (false)}
                  handleClose={handleModalClose}

                handleSubmit={handleSubmit}
                formData={formData}
                handleInputChange={handleInputChange}
                errors={errors}
                isEdit={isEdit}
            /> */}
            {/* <ContactModal
                showModal={showContactModal} // Use the prop
                handleClose={handleModalClose}
                handleSubmit={handleSubmit}
                formData={formData}
                handleInputChange={handleInputChange}
                errors={errors}
                isEdit={isEdit}
            /> */}

            {!onShowModal && (
                <ContactModal
                    showModal={showContactModal} // Use the prop
                    handleClose={handleModalClose}
                    handleSubmit={handleSubmit}
                    formData={formData}
                    handleInputChange={handleInputChange}
                    errors={errors}
                    isEdit={isEdit}
                />
            )}
            {/* {showContactModal && (
  <div className="modal-backdrop">
    <div className="modal-content">
      <h5>{isEdit ? "Edit Contact" : "Add Contact"}</h5>
      <input name="name" value={formData.name} onChange={handleInputChange} />
      <input name="email" value={formData.email} onChange={handleInputChange} />
      <input name="phone" value={formData.phone} onChange={handleInputChange} />
      <button onClick={handleSubmit}>Save</button>
      <button onClick={handleModalClose}>Close</button>
    </div>
  </div>
)} */}


        </div>
    );
});

export default SelectedContact;



// return (
//     <>



//             <div>
//                 <form>
//                     <div className="row">
//                         <div className="col-xl col-sm-6 d-flex justify-content-end">
//                             <div>
//                             <div className="search-box me-2">
//                         <div className="position-relative">
//                             <input
//                                 type="text"
//                                 className="form-control font-size-12"
//                                 placeholder="Search..."
//                                 value={searchQuery}
//                                 onChange={handleSearchChange}
//                             />
//                             <i className="bx bx-search-alt search-icon" />
//                         </div>
//                     </div>
//                                 {isDropdownOpen && filteredContacts.length > 0 && (
//                                     <div
//                                         ref={dropdownRef}
//                                         className="dropdown"
//                                         style={{

//                                             width: '280px',
//                                             zIndex: 500
//                                         }}
//                                     >
//                                         <ul
//                                             className="dropdown-menu p-2 shadow-sm rounded"
//                                             style={{
//                                                 display: 'block',
//                                                 maxHeight: '200px',
//                                                 overflowY: 'auto',
//                                                 width: '200px',
//                                                 backgroundColor: '#ffffff',
//                                             }}
//                                         >
//                                             {filteredContacts.map(contact => (
//                                                 <li
//                                                     key={contact.id}
//                                                     className="dropdown-item d-flex align-items-center gap-2 px-3 py-2"
//                                                     style={{
//                                                         cursor: 'pointer',
//                                                         transition: 'background-color 0.2s ease-in-out',
//                                                     }}
//                                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
//                                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
//                                                 >
//                                                     <input
//                                                         type="checkbox"
//                                                         className="form-check-input"
//                                                         checked={selectedContacts.some(c => c.id === contact.id)}
//                                                         onChange={() => handleSelectContact(contact)}
//                                                     />
//                                                     <span className="fw-semibold">{contact.name}</span>
//                                                 </li>
//                                             ))}
//                                         </ul>

//                                     </div>
//                                 )}
//                             </div>
//                             <button
//                                         type="button"
//                                         className="btn rounded-circle border d-flex align-items-center justify-content-center round-plus"

//                                         onClick={handleAddContact}
//                                         data-bs-toggle="tooltip"
//                                         data-bs-placement="top"
//                                         id="tool"
//                                         title="Add Contacts"
//                                     >
//                                         <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
//                                     </button>
//                         </div>


//                     </div>
//                 </form><br />
//                 <div className="table-responsive mt-2">
//                     <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13">
//                         <thead>
//                             <tr>
//                                 <th scope="col">Name</th>
//                                 <th scope="col">Email</th>
//                                 <th scope="col">Phone</th>
//                                 <th scope="col">Position</th>
//                                 <th scope="col">Contact Type</th>
//                                 {entityType === 'project' && <th>Notify</th>}
//                                 <th scope="col">Action</th>
//                                 <th>

//                                 </th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {selectedContacts.length ? (
//                                 selectedContacts.map(contact => (
//                                     <tr key={contact.id}>
//                                         <td>{contact.name}</td>
//                                         <td>{contact.email}</td>
//                                         <td>{contact.phone}</td>
//                                         <td>
//                                         {editingPositionId === contact.id ? (
//                     <div className="d-flex align-items-center gap-2">
//                         <input
//                             type="text"
//                             value={contact.position || ''}
//                             onChange={(e) => handlePositionChange(contact.id, e.target.value)}
//                             className="form-control form-control-sm "
//                             style={{ width: '150px' }}
//                         />
//                         {/* Save Button */}
//                         <BsCheck className="text-success mx-2"
//                             onClick={() => savePosition(contact.id)}
//                         />

//                         {/* Cancel Button */}
//                         <BsX className="text-danger"
//                             onClick={() => setEditingPositionId(null)}
//                         />
//                     </div>
//                 ) : (
//                     <span
//                         style={{ cursor: 'pointer'}}
//                         onClick={() => setEditingPositionId(contact.id)}
//                     >
//                         {contact.position || ''}
//                     </span>
//                 )}
//                                         </td>
//                                         <td>{contact.contact_type || ''}</td>
//                                         {entityType === 'project' && (
//                                             <td>
//                                                 <input
//                                                     type="checkbox"
//                                                     checked={contact.pivot?.sendemail_to_project === "true"} // This ensures the checkbox is checked if "true"
//                                                     onChange={() => handleNotifyToggle(contact.id)} />
//                                             </td>
//                                         )}
//                                         <td>
//                                             <button
//                                                 style={{ cursor: 'pointer', color: 'grey' }}
//                                                 onClick={() => handleDeleteContact(contact.id)}
//                                                 className="btn btn-sm"
//                                             >
//                                                 <i className="fa fa-trash"></i>
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="6">No contacts selected.</td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//                 {shouldShowSaveButton && (
//                     <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
//                         <button onClick={updateContacts} className="btn btn-secondary">
//                             Save
//                         </button>
//                     </div>
//                 )}
//             </div>




//         <ContactModal
//             showContactModal ={showContactModal }
//             handleClose={() => setshowContactModal (false)}
//             handleSubmit={handleSubmit}
//             formData={formData}
//             handleInputChange={handleInputChange}
//             errors={errors}
//             isEdit={isEdit}
//         />
//     </>
// );


